import { render, staticRenderFns } from "./AdminArea.vue?vue&type=template&id=59b223e7&scoped=true&"
import script from "./AdminArea.vue?vue&type=script&lang=js&"
export * from "./AdminArea.vue?vue&type=script&lang=js&"
import style0 from "./AdminArea.vue?vue&type=style&index=0&id=59b223e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b223e7",
  null
  
)

export default component.exports